export const SIDEBAR_CONTENT_TYPE = {
  CONTENT_UNITS: 'Content Units',
  INSURED: 'Insured',
  TEMPLATES: 'Templates',
  CERTIFICATE_HOLDERS: 'Certificate Holders',
  CERTIFICATES: 'Certificates'
} as const

export const SIDEBAR_ROUTES = {
  CONTENT_UNIT_PATH: '/content-unit',
  INSURED_PATH: '/insured',
  TEMPLATE_PATH: '/template',
  CERTIFICATE_HOLDER_PATH: '/certificate-holder',
  CERTIFICATE_PATH: '/certificate'
} as const
